import ReportRekapDelivery from '@/models/ReportRekapDelivery/ReportRekapDelivery';

export default class ReportRekapDeliveryFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.filterCustomer = '';
		this.filterPart = '';
		this.filterPoNoCustomer = '';
		this.filterSuratJalanNumber = '';
		this.filterDiDeliveryDateFrom = '';
		this.filterDiDeliveryDateTo = '';
		this.tempId = '';
		this.deliveryDateFrom = '';
		this.deliveryDateTo = '';
		this.suratJalanNumber = '';
		this.poNoCustomer = '';
		this.partNumber = '';
		this.partName = '';
		this.deliveryQty = '';
		this.customerName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			filterCustomer : '0',
			filterPart : '0',
			filterPoNoCustomer : '0',
			filterSuratJalanNumber : '0',
			filterDiDeliveryDateFrom : '0',
			filterDiDeliveryDateTo : '0',
			tempId : '0',
			deliveryDateFrom : '0',
			deliveryDateTo : '0',
			suratJalanNumber : '0',
			poNoCustomer : '0',
			partNumber : '0',
			partName : '0',
			deliveryQty : '0',
			customerName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}